import {
    Network, Zap, Router, ShieldCheck, Wifi, Radio, Video, HardDrive, Server, Boxes,
    BatteryCharging, Cpu, Cable, LayoutGrid, Repeat, Package, Phone, Camera, ServerCog,
} from "lucide-react";

// Brand → primary color (approximated from official brand guidelines)
export const BRAND_COLORS = {
    "Cisco": "#049FD9",
    "Juniper Networks": "#0F674F",
    "HPE Aruba Networking": "#FF8300",
    "HPE": "#01A982",
    "Fortinet": "#EE3124",
    "Ubiquiti": "#0559C9",
    "MikroTik": "#293239",
    "TP-Link": "#0FA9C2",
    "D-Link": "#003D6E",
    "Netgear": "#00579B",
    "Dell Technologies": "#007DB8",
    "Lenovo": "#E2231A",
    "Synology": "#1B466C",
    "QNAP": "#F08F00",
    "APC by Schneider Electric": "#3DCD58",
    "Vertiv": "#57267C",
    "Ruckus Networks": "#D82128",
    "Huawei": "#C7000B",
    "Extreme Networks": "#522D80",
    "Allied Telesis": "#0B3A67",
    "CommScope": "#1B75BB",
    "Panduit": "#005EB8",
    "Belden": "#C8102E",
    "Corning": "#005151",
    "Quantum": "#78BE20",
    "Molex": "#E30613",
};

// Category → lucide icon
export const CATEGORY_ICONS = {
    "Core Switches": Network,
    "Managed & Unmanaged PoE Switches": Zap,
    "Enterprise Routers": Router,
    "Firewalls": ShieldCheck,
    "Wireless Access Points": Wifi,
    "Wi-Fi Controllers": Radio,
    "NVRs": Video,
    "NAS Storage": HardDrive,
    "Rack Servers": Server,
    "Server Cabinets & Network Racks": Boxes,
    "UPS Systems": BatteryCharging,
    "SFP/SFP+/QSFP Modules": Cpu,
    "Fiber Optic Cables & Patch Cords": Cable,
    "Patch Panels": LayoutGrid,
    "Cat6/Cat6A/Cat7 Cables": Cable,
    "Media Converters": Repeat,
    "Network Accessories": Package,
    "IP Phones": Phone,
    "CCTV Networking Equipment": Camera,
    "Data Center Networking Products": ServerCog,
};

export const brandColor = (brand) => BRAND_COLORS[brand] || "#1E90FF";
export const categoryIcon = (category) => CATEGORY_ICONS[category] || Network;
